import { name } from "./block.json";

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
  const toggleButtonElement = block.querySelector<HTMLButtonElement>('.wp-block-site-specifics-head__toggle-button');

	toggleButtonElement?.addEventListener('click', function(event) {
		const specificsElement = block.closest<HTMLElement>('.wp-block-site-specifics');
		const detailsElements = specificsElement?.querySelectorAll<HTMLDetailsElement>('details')

		if ('true' !== toggleButtonElement.ariaPressed) {
			block.classList.add('open');
			toggleButtonElement.ariaPressed = 'true';

			detailsElements?.forEach((detailsElement) => {
				detailsElement.open = true;
			});
		} else {
			block.classList.remove('open');
			toggleButtonElement.ariaPressed = 'false';

			detailsElements?.forEach((detailsElement) => {
				detailsElement.open = false;
			});
		}
	})
}
